export const blockIconsSearchCoffeeMaker = (
	<span className='material-symbols-outlined'>coffee_maker</span>
);
